import React from 'react';
import { Route } from 'react-router-dom';

export function PrivateRouteOffline({ component: Component, ...rest }) {
    return (
        <Route
            {...rest}
            render={props => <Component {...props} />}
        />
    );
}